import { EditCompetencePage } from "@features/rh/competences/components/EditCompetencePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/rh/competences/$id/edit")({
  staticData: {
    title: "Modifier compétence",
    showInBreadcrumb: true,
  },
  component: EditCompetencePage,
});
